/**
 * 店铺资质展示
 * 只展示当前文件下的店铺
*/

export const merchants = [
    {
        storeId: '5f8e7567fd9d5f7407f04585',
        img: [
            'https://fr-static.shopshops.top/20210406/qualification.774df1be04938fbe.jpg'
        ]
    },
    {
        storeId: '600fa046d1592b50c7595a05',
        img: [
            'https://fr-static.shopshops.top/20210406/qualification_1.a6d8e803de0cce05.jpg'
        ]
    },
    {
        storeId: '5f86c467f36df81f49a7e9fa',
        img: [
            'https://fr-static.shopshops.top/20210406/qualification_4.4d6840279fcd6ea2.jpg'
        ]
    },
    {
        storeId: '5ea3a90413ae757c5722a847',
        img: [
            'https://fr-static.shopshops.top/20210406/qualification_3.cd39c3ecd23c57d3.jpg'
        ]
    },
    {
        storeId: '5ebcbac12ed0a518dbd83f96',
        img: [
            'https://fr-static.shopshops.top/20210406/qualification_2.eb0dd6eee27cdc56.jpg'
        ]
    },
    {
        storeId: '5d36c8610d52710d008b4745',
        img: [
            'https://fr-static.shopshops.top/20210407/qualification_5.0b4b9525ace5455d.jpg'
        ]
    },
    {
        storeId: '5ed617dfc8d9956ba10b5e8c',
        img: [
            'https://fr-static.shopshops.top/20210407/qualification_6.3dd24279525f8b6e.jpg'
        ]
    }
]

export const personal = [
    {
        storeId: '5fed7d0fb69237576734adcb',
        hostId: '5d3837aeb2e8b8000a5592a7'
    },
    {
        storeId: 'f6a4d35d0f2652da8111a369',
        hostId: '5d6a45031d7912001419eae2'
    },
    {
        storeId: '9f99b7e5a95f8e61150cdc87',
        hostId: '5d153a779624b0000a3e6662'
    },
    {
        storeId: '5f8de311fd9d5f7407f04583',
        hostId: '5f8de25ceaba390d72bd15f0'
    },
    {
        storeId: 'db6c1cf76abf3508a9d74537',
        hostId: '5d611c0e0c97b500161fd1e9'
    },
    {
        storeId: 'db6c1cf76abf3508a9d74537',
        hostId: '5d611c0e0c97b500161fd1e9'
    },
    {
        storeId: '5ef9bad34a78616f07baf9ef',
        hostId: '5ee743f8c1d39d163fb94f35'
    },
    {
        storeId: '5e3eb454fc1cb775b54e151c',
        hostId: '5dd61257f0823b3d2799328d'
    },
    {
        storeId: '5e267b50acc3c12fe8dee3d0',
        hostId: '5d7f0338f6deab0009537216'
    },
    {
        storeId: 'a9dc0ae262db26264ffc2320',
        hostId: '5d7f0338f6deab0009537216'
    },
    {
        storeId: '5dbfa1f08d060c51551109af',
        hostId: '5ce37fd412ec870f008b456b'
    },
    {
        storeId: '7d03849b13db5812423da059',
        hostId: '5d2541a318281f000b5bde08'
    },
    {
        storeId: 'dc4d050ccc0826b206a02893',
        hostId: '5df6f2de011cfe1a3ce12cca'
    },
]